import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=7f21a728&scoped=true&"
import script from "./headline.vue?vue&type=script&lang=js&"
export * from "./headline.vue?vue&type=script&lang=js&"
import style0 from "./headline.vue?vue&type=style&index=0&id=7f21a728&prod&lang=less&scoped=true&"
import style1 from "./headline.vue?vue&type=style&index=1&id=7f21a728&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21a728",
  null
  
)

export default component.exports